module.exports = __webpack_public_path__ + "static/media/icon-moon.c723316e.svg";